const outdatedApplicationDictionary = {
  outdatedApplication: {
    heading: "An updated version is available",
    text: "To access the latest features and improvements, kindly refresh your browser.",
    reloadButton: "Refresh now",
    postponeButton: "Snooze"
  }
};
export {
  outdatedApplicationDictionary
};
//# sourceMappingURL=outdatedApplicationDictionary.js.map
